import { render, staticRenderFns } from "./date-edit.vue?vue&type=template&id=bc0ad882"
import script from "./date-edit.vue?vue&type=script&lang=ts"
export * from "./date-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports